import React, { useEffect, useState } from 'react';
import { Form, Input, Button } from 'antd';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { doResetPassword } from '../../../modules/auth/stores/thunk';
import './Auth.scss';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const ResetPasswordForm = ({ token }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const { message } = useSelector((state) => state.common);

  useEffect(() => {
    if (message) {
      history.push('/');
    }
  }, [message]);

  const handleSubmit = (params) => {
    dispatch(doResetPassword({ ...params, token }));
  };
  const [disabled, setDisabled] = useState(true);

  const handleFormChange = async () => {
    // Check if the form is valid
    return new Promise(() => {
      setTimeout(() => {
        form
          .validateFields()
          .then(() => setDisabled(false))
          .catch(() => setDisabled(true));
      });
    });
  };

  return (
    <div className="ResetPasswordForm">
      <Form
        form={form}
        scrollToFirstError
        layout="vertical"
        hideRequiredMark
        colon={false}
        onFinish={handleSubmit}
        onValuesChange={handleFormChange}
      >
        <div className="Logo">
          <Link to="/">
            <img src={`/logo.svg`} alt="logo" />
          </Link>
        </div>
        <div className="FormHeader">
          <div className="Title">Create New Password</div>
          <div className="SubTitle">Create a new password and login again to your account</div>
        </div>
        <div className="FormContent">
          <Form.Item
            label="Password"
            name="password"
            rules={[
              { min: 12, message: 'At least 12 characters' },
              { pattern: /[a-z]/, message: 'Should contain lowercase character' },
              { pattern: /[A-Z]/, message: 'Should contain uppercase character' },
              { pattern: /[0-9]/, message: 'Should contain number' },
              {
                pattern: /[!@#$%^&*()\-_<>~]/,
                message: 'Should contain a special character like  !@#$%^&*()-_<>~',
              },
              { required: true, message: 'Required' },
            ]}
          >
            <Input.Password size="large" placeholder="Password" />
          </Form.Item>
        </div>
        <div className="FormFooter">
          <Button type="primary" htmlType="submit" block size="large" disabled={disabled}>
            Update Password
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default ResetPasswordForm;
